import React from "react"
import ComponentWithData from "~/utils/ComponentWithData"
import {
  TitleSection,
  DetailInfoRow,
  SearchableList,
  ListItemUser,
  Button
} from "~/components/"
import {Tenant} from "~/utils/ShelfEntities"
import {withTranslation} from "react-i18next"

class TenantDetailsView extends ComponentWithData {
  renderLoading() {
    return <p>{this.props.t("tenants.detail.loading")}</p>
  }

  getFilteredItems(query) {
    let lowerCaseQuery = query.toLowerCase()
    return this.state.data.users.filter(user =>
      user.email.toLowerCase().includes(lowerCaseQuery)
    )
  }

  update() {
    this.getData()
  }

  getData() {
    Tenant.find(this.props.match.params.tenantName)
      .then(tenants => {
        this.setState({data: tenants, resource_loader_state: "successful"})
      })
      .catch(err => {
        console.log("Error loading tenants data: " + err)
      })
  }

  componentDidMount() {
    this.getData()
  }

  renderWithData() {
    return (
      <div className="sh-tenant-details">
        <TitleSection>
          <h3>{this.props.t("tenants.detail.informations")}</h3>
        </TitleSection>

        <DetailInfoRow
          label={this.props.t("tenants.detail.nameSubdomain")}
          value={this.state.data.name}
        />

        <TitleSection>
          <h3>User</h3>
        </TitleSection>
        <SearchableList
          filteredItems={this.getFilteredItems.bind(this)}
          itemRenderer={ListItemUser}
          update={this.update.bind(this)}
          renderActions={() => (
            <Button
              primary
              to={this.props.match.params.tenantName + "/users/new"}
              icon="plus"
              label={this.props.t("tenants.detail.newUser")}
            />
          )}
        >
          <p>{this.props.t("tenants.detail.noUsers")}</p>
        </SearchableList>

        <TitleSection>
          <h3>{this.props.t("tenants.detail.settings")}</h3>
        </TitleSection>
        <div className="sh-detail-view">
          <p>
            {this.props.t("tenants.detail.articlesPerLocation")}:
            <strong>
              {" "}
              {this.state.data.articlesPerLocation === -1
                ? this.props.t("tenants.detail.noLimit")
                : this.state.data.articlesPerLocation}{" "}
            </strong>
          </p>
          <p>
            {this.props.t("tenants.detail.stockOutStrategy")}:
            <strong> {this.state.data.stockOutStrategy.toUpperCase()} </strong>
          </p>
          <p>
            {this.props.t("tenants.detail.prioritizeAlreadyOpenedArticles")}:
            <strong>
              {" "}
              {this.state.data.prioritizeAlreadyOpenedArticles
                ? this.props.t("yes")
                : this.props.t("no")}{" "}
            </strong>
          </p>

          <Button
            primary
            to={"/settings/" + this.props.match.params.tenantName}
            label={this.props.t("tenants.detail.editSettings")}
          />
        </div>
      </div>
    )
  }
}

TenantDetailsView.propTypes = {}

export default withTranslation()(TenantDetailsView)



// WEBPACK FOOTER //
// ./src/views/detail/TenantDetailView.js